<div style="padding: 20px;">
  <div class="table-card">
    <div class="table-header">
      <h2 class="table-title">{{ formatText(subMenu) }}</h2>
      <mat-form-field appearance="outline" class="custom-seash-input">
        <mat-label>Search</mat-label>
        <input matInput (keyup)="applyFilter($event)" [placeholder]="formatText(subMenu)" />
      </mat-form-field>
      <button mat-flat-button color="primary" class="reset-btn" (click)="ExportTOExcel()" [disabled]="count == 0">Export
        As Excel</button>
    </div>
    <mat-divider style="margin-bottom: 10px;"></mat-divider>
    <table mat-table matSort [dataSource]="dataSource" class="workorder-table">
      <ng-container matColumnDef="ManufacturerName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Manufacturer Name</th>
        <td mat-cell *matCellDef="let report">
          {{ report.ManufacturerName }}
        </td>
      </ng-container>
      <ng-container matColumnDef="DistributorName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Distributor Name</th>
        <td mat-cell *matCellDef="let report">
          {{ report.DistributorName }}
        </td>
      </ng-container>
      <ng-container matColumnDef="ProgramType">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Program Type</th>
        <td mat-cell *matCellDef="let report">
          {{ report.ProgramType }}
        </td>
      </ng-container>
      <ng-container matColumnDef="ManufacturerCode">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Manufacturer Code</th>
        <td mat-cell *matCellDef="let report">
          {{ report.ManufacturerCode }}
        </td>
      </ng-container>
      <ng-container matColumnDef="DistributorCode">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Distributor Code</th>
        <td mat-cell *matCellDef="let report">
          {{ report.DistributorCode }}
        </td>
      </ng-container>
      <ng-container matColumnDef="LastModifiedDate">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>LastModified Date</th>
        <td mat-cell *matCellDef="let report">
          {{ report.LastModifiedDate }}
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
    <ng-container *ngIf="count == 0 || dataSource?.data.length === 0">
      <div class="no-records">No records found.</div>
    </ng-container>
    <mat-paginator [pageSizeOptions]="[10,20,30]" showFirstLastButtons></mat-paginator>
  </div>
</div>